import { render, staticRenderFns } from "./Keyboard65GameBoy.vue?vue&type=template&id=7204a28e&scoped=true&"
import script from "./Keyboard65GameBoy.vue?vue&type=script&lang=js&"
export * from "./Keyboard65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard65GameBoy.vue?vue&type=style&index=0&id=7204a28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204a28e",
  null
  
)

export default component.exports